import * as React from "react";

const locales = {
  en: {
    Account: "Account",
    AccountDeactivated: "Account for {placeholder} has been deactivated. Please contact your administrator for assistance.",
    AccessDenied: "Access denied",
    AccessRevoked: "Your access for {placeholder} has been revoked",
    ActionFailed: "Action failed. Please try again later.",
    ActionSucceed: "Action succeeded!",
    AddAttachment: "As attachments",
    Add: "Add",
    AddEmail: "Add to Email",
    AddFiles: "Add files",
    AddFilesAdditional: "Add additional files",
    AddShareableLink: "As links",
    AdvancedSearch: "Advanced search",
    All: "All",
    AllAlt: "All",
    AllowApprovals: "Enable my approvals",
    AllowApprovalsMessage: "Enable Docubird to access your approvals information.",
    AlreadyAssigned: "Already assigned to this approval",
    AlreadyExists: "Already exists",
    App: "app",
    Apply: "Apply",
    Approval: "Approval",
    ApprovalCenter: "Tasks",
    ApprovalRequestNotAllowedOwner: "The approval request may not be reassigned to the approval owner.",
    ApprovalsLoading: "Loading approvals...",
    ApprovalsShownHere: "Approvals will be shown here.",
    Approvers: "Approvers",
    Approve: "Approve",
    Ascending: "Ascending",
    AsPdf: "as Pdf",
    Attachments: "Attachments",
    AttachmentsSelected: "attachments selected",
    AttentionSaveModeActive: "Attention: please note that you are still in email save mode!",
    AutoFolderCreationNoContent: "Use the search field above to find documents and folders.",
    Automation: "Automation",
    AutomationFlowDescription: "Automation process description",
    AutomationFlowName: "Automation process name",
    AutomationFlowNotSelected: "No automation process selected",
    AutomationFlowRequest: "Automation request",
    AutomationFlowRequestError: "Automation request failed",
    AutomationFlowRequestSuccess: "Automation request successfully sent",
    AutoOpenDocubird: "Auto open Docubird for this document?",
    AutoSelectAttachments: "Auto select attachments",
    AutoRemoveMailItemAttachments: "Remove attachments on mail item save",
    AutoSetEmailProperty: "[Autoset to email property '{emailProperty}']",
    AvailableFiles: "Available files",
    Back: "Back",
    BackToWork: "Get Back To Work",
    Bcc: "Bcc",
    BlockDownload: "Block download",
    Browser: "browser",
    By: "by",
    CanEditMakesChanges: "Can edit - Make any changes",
    CanViewCannotMakeChanges: "Can view - Cannot make changes",
    Cancel: "Cancel",
    CancelApproval: "Cancel approval",
    CancelAssignment: "Cancel assignment",
    CancelAssignmentConfrimMessage: "Are you sure you want to cancel the assignment?",
    Categories: "Categories",
    Cc: "Cc",
    Channels: "Channels",
    CheckIn: "Check in",
    CheckOut: "Check out",
    CheckedOutBy: "Checked out by",
    CheckedOutByYou: "You checked out this item",
    ChooseVersion: "Choose version",
    Clear: "Clear",
    ClearSearch: "Clear search",
    ClearFilter: "Clear filter",
    Close: "Close",
    Comment: "Comment",
    Confirm: "Confirm",
    ConfirmPublish: "Do you want to publish?",
    ConfirmDeleteMailbox: "Are you sure you want to delete {mailbox}?",
    ContactAdministrator: "Please contact your administrator for assistance.",
    ContactUs: "Please feel free to contact us for an appropriate quote.",
    ContentManager: "Content Manager",
    ContentType: "Content Type",
    ContentTypes: "Content Types",
    Continue: "Continue",
    ConversationIndex: "Conversation-index",
    ConversationTopic: "Conversation-topic",
    ConvertEmailToPdf: 'Convert email to pdf on save',
    ConvertToPdf: 'Convert to PDF',
    CopyItems: "Copy items",
    CopyingItems: "Copying items...",
    CopyProgress: "Copy progress",
    CopyProgressCounter: "{completed} of {total} items copied",
    CopyAll: "Copy all",
    CopyTo: "Copy to",
    Create: "Create",
    Created: "Created",
    CreateWithAttachments: "With attachments",
    CreateWithShareableLinks: "With links",
    CreateEmail: "Create Email",
    CreateEmailWithAttachment: "Create Email with attachment",
    CreateEmailWithLink: "Create Email with link",
    Datasource: "datasource",
    Date: "Date",
    Default: "Default",
    Delete: "Delete",
    Deleting: "Deleting",
    DeleteSPItemConfirmMessage: "Are you sure you want to send this item(s) to the site recycle bin?",
    Descending: "Descending",
    Description: "Description",
    Details: "Details",
    DiscardCheckOut: "Discard check out",
    Disconnect: "Disconnect",
    DocumentLibraries: "Document Libraries",
    DocumentLibrary: "Document library",
    DocumentSettings: "Document settings",
    DocumentSharedWithYouBy: "This is the document shared with you by [person].",
    DocumentSharedWithYouByEmailSubject: "[person] shared \"[file_name]\" with you.",
    DocumentShareSuccess: "\"[file_name]\" successfully shared",
    Done: "Done",
    Download: "Download",
    Downloading: "Downloading",
    DownloadAsPdf: "Download as pdf",
    DownloadAsPdfFailure: "Unable to convert the file to pdf format. The file might be an incorrect format, too large, or possibly corrupt.",
    DownloadFailure: "Download Failure",
    DownloadingAttachments: "Downloading attachments",
    DoYouWantToCreateFolder: "Do you want to save the emails to a new folder?",
    Draft: "Draft",
    DueDate: "Due date",
    DueDateDescription: "Standard {days} days.",
    DuplicateResolved: "Your duplicate file names have been resolved. You can continue saving!",
    EditXItems: "Edit {itemCount} items",
    EmailHeaderMapping: "Email headers mapping",
    Emails: "Emails",
    Empty: "Empty",
    EnableEmails: "Enable emails",
    EnterDate: "Enter a date",
    EnterEmail: "Enter names, emails, or user groups",
    EnterFolderName: "Please enter a folder name",
    EntireFolderSelected: "Entire folder selected",
    Error: "Error",
    ErrorMessageGeneric: "Something went wrong",
    ErrorDeletingFiles: "There was an error deleting one or more files",
    ErrorConnectingToServer: "Error connecting to the server",
    ErrorWhileUpdatingMetadata: "There was an error while updating your metadata",
    ExchangeSettings: "Exchange settings",
    FetchProgressCounter: "{total} items fetched",
    FetchProgressCounterAll: "Fetching all items...",
    FieldRequired: "Field is required",
    FileBackgroundSave: "Your files are saving in the background...",
    FileBackgroundSaveFailure: "Something went wrong",
    FilesNotSuccessfullyUploaded: "The following files were not successfully uploaded",
    FileDeleted: "File deleted",
    FileInfo: "File info",
    FileLocationError: "Cannot open file location.",
    FileLocationUnknown: "File location unknown",
    FileNotFound: "File not found",
    FileRecentlyDeleted: "The file was recently deleted and is not available anymore",
    FileNotExist: "File does not exist anymore!",
    FileNotSaved: "Please ensure that your file has been locally saved!",
    FileSelected: "File selected",
    FilesSelected: "Files selected",
    FilesSelectedToUpload: "file(s) selected to upload",
    Files: "Files",
    FileSaveSuccess: "Your files have been successfully saved",
    FileSaveSuccessSingle: "File successfully saved",
    FileSameCheckedOut: "A file with this name is already checked out",
    FileCurrentlyCheckedOut: "This file is currently checked out",
    FileSameLocked: "A file with this name is locked",
    FileSameName: "A file with this name already exists",
    FileVersionLimitReached: "File version limit reached",
    Filter: "Filter",
    FilterDateStepSince: "Since",
    FilterDateStepLast3Months: "In the last 3 months",
    FilterDateStepLast30Days: "In last 30 days",
    FilterDateStepLast7Days: "In last 7 days",
    FilterDateStepSinceYesterday: "Since yesterday",
    FilterDateStepToday: "Today",
    FilterDateStepTomorrow: "Tomorrow",
    FilterDateStepIn7Days: "In 7 days",
    FilterDateStepIn30Days: "In 30 days",
    FilterDateStepIn3Months: "In 3 months",
    FilterDateStepInAYearOrMore: "In a year or more",
    FilterDateStepIn3MonthsOrMore: "In 3 months or more",
    FilterResults: "Filter results",
    Finished: "All done",
    FolderNotExist: "Folder does not exist anymore!",
    Folder: "Folder",
    Folders: "Folders",
    FolderCreate: "Create new folder",
    FolderCreateSuccess: "The folder has been successfully created",
    FolderDeleted: "Folder deleted",
    FolderName: "Folder name",
    FolderRecentlyDeleted: "The folder was recently deleted and is not available anymore",
    FolderSameName: "A folder with this name already exists",
    FolderSameNameAutoRename: "A folder or folders with the same name(s) already exists. The uploaded folder(s) will be automatically renamed upon upload.",
    FolderType: "Folder type",
    FollowedSites: "Followed sites",
    From: "From",
    GenericNoResultsFoundText: "No results found",
    Group: "Group",
    HidePreview: "Hide preview",
    History: "History",
    Home: "Home",
    HubAssociatedHubs: "Associated hub sites",
    HubAssociatedSites: "Associated sites",
    HubSite: "Hub site",
    IndividualFilesUpdated: "Individual files updated",
    Importance: "Importance",
    InReplyTo: "In reply to",
    InsertAsAttachment: "Insert as Attachment",
    InsertAsLink: "Insert as Link",
    InsertFrom: "Insert from",
    InvalidEmail: "Invalid email",
    Item: "Item",
    Items: "Items",
    ItemsToAddAsAttachmentsLinks: "Items to add as {placeholder}",
    ItemToCopy: "Item to copy",
    ItemsToCopy: "Items to copy",
    ItemToMove: "Item to move",
    ItemsToMove: "Items to move",
    ItemsSelected: "items selected",
    LandingPage: "Landing page",
    LargestOnTop: "Largest on top",
    LeastRelevantOnTop: "Least relevant on top",
    LevelUp: "Level up",
    LibraryPermissions: "Library Permissions",
    LicenseRequired: "In order to have access to {placeholder} you need to have a paid license.",
    LicenseRequiredTitle: "License required",
    LimitReached: "Limit reached",
    Link: "Link",
    ListItemPickerSelectValue: "Select value",
    List: "List",
    Lists: "Lists",
    ListItem: "List item",
    Loading: "Loading ...",
    LoadingOnly: "Loading",
    LoadingFilters: "Loading filters",
    LoadingInputs: "Loading Inputs",
    LoadingProfile: "Loading profile ...",
    LoadDefaults: "Load defaults",
    LoadMore: "Load more results",
    LoadingEmails: "Loading emails",
    Local: "local",
    Location: "Location",
    Locations: "Microsoft 365 locations",
    MailboxAddress: "Mailbox address",
    MailboxAuthorizing: "Authorizing mailbox",
    MailboxAlreadyAdded: "Mailbox already added",
    Manage: "Manage",
    MaximumEmailMessagesSelected: "Maximum of {amount} email messages may be saved at once.",
    Me: "Me",
    Member: "Member",
    Members: "Members",
    MembersAdd: "Add members",
    MemberSelect: "Select member",
    MembersNotSelected: "No members selected",
    MembersNotFound: "No members found",
    Message: "Message",
    MessageId: "Message-ID",
    MetadataNotUpdated: "Files were saved successfully. Make sure that the metadata has been updated accordingly",
    MetadataValidationFailed: "Validation failed for",
    MinorVersions: "Minor versions",
    Modified: "Modified",
    ModifiedBy: "Modified by",
    More: "More",
    MoreActions: "Show actions",
    MostRelevantOnTop: "Most relevant on top",
    MoveItemUp: "Move pinned item up",
    MoveItemDown: "Move pinned item down",
    MoveItems: "Move items",
    MovingItems: "Moving items...",
    MoveProgress: "Move progress",
    MoveProgressCounter: "{completed} of {total} items moved",
    MoveAll: "Move all",
    MoveTo: "Move to",
    MyApprovals: "My approvals",
    Name: "Name",
    New: "New",
    NewestOnTop: "Newest on top",
    NewOnly: "New",
    No: "No",
    NoAppSpecificFiles: "No {context} files found.",
    NoEmailAvailable: "No email available",
    NoFiltersAvailable: "No filters available",
    NoFilesSelected: "No files selected",
    NoItemsFound: "No items found!",
    NoMoreFolders: "No folders are located in this directory!",
    NoMoreFoldersAndFiles: "This directory is empty.",
    NoLocations: "No further locations",
    NotAssignedToTeam: "You are not a member of any teams.",
    NotAssignedToSite: "You are not assigned to any sites.",
    NoResultsFound: "No results found",
    NoSubject: "No subject",
    NotWorkingOnOnlineVersion: "You are not working on the online version of this document.",
    Of: "of",
    Ok: "Ok",
    OldestOnTop: "Oldest on top",
    OneDrive: "OneDrive",
    OneOrMoreFilesLockedCheckedOut: "One or more files locked/checked out",
    Open: "Open",
    OpenFileInBrowser: "Open file in browser",
    OpenFileLocation: "Open file location",
    OpenFileLocationIn: "Open file location in",
    OpenIn: "Open in",
    OpenFolder: "Open folder",
    OpenOnlineDocumentWith: "Open the document in",
    OpenFolderInBrowser: "Open location in browser",
    OptionalComment: "Add a comment (optional)",
    Options: "Options",
    OutlookSettings: "Outlook settings",
    OriginalSubject: "Original subject",
    Overview: "Overview",
    Overwrite: "Overwrite/version existing files",
    OverwriteRequired: "Change the conflicting file name/s or choose the option to overwrite/version existing files.",
    Owner: "Owner",
    Participants: "Participants",
    Permissions: "Permissions",
    Pinned: "Pinned",
    PinnedItemsShownHere: "Pinned items will be shown here.",
    PinThisFile: "Pin this file",
    PinThisFolder: "Pin this location",
    PleaseSelectSomeoneShare: "Please select someone to share with",
    PriceLinkText: "You can view our prices here.",
    PrivacySensitiveChecking: "Checking for privacy sensitive data",
    PrivacySensitiveCheckError: "Error checking for privacy sensitive data",
    PrivacySensitiveDisplay: "Privacy sensitive",
    PrivacySensitiveDataFound: "Privacy sensitive data found",
    PrivacySensitiveDataNotFound: "No privacy sensitive data found",
    PrivacySensitiveDataNotChecked: "Privacy sensitive data not checked",
    PrivacySensitiveRedact: "Redact privacy sensitive data",
    Private: "Private",
    Preferences: "Preferences",
    PreparingCopy: "Preparing copy operation...",
    PreparingMove: "Preparing move operation...",
    Properties: "Properties",
    Publish: "Publish",
    PublishedMajorVersion: "Current published major version",
    QuickAccess: "Quick access",
    ReadMore: "Read More...",
    ReadOnly: "Read-only",
    Reason: "Reason",
    Reassign: "Reassign",
    ReassignTo: "Reassign to",
    Recipients: "Recipients",
    Received: "Received",
    Recent: "Recent",
    RecentlyEditYou: "You recently edited this",
    RecentlyOpened: "Recently opened",
    RecentlyOpenedYou: "You recently opened this",
    RecentItemsShownHere: "Recent items will be shown here.",
    Recheck: "Recheck",
    Recommended: "Recommended",
    Redact: "Redact",
    References: "References",
    Refresh: "Refresh",
    Reject: "Reject",
    Relevance: "Relevance",
    Remove: "Remove",
    RemoveFromRecent: "Remove from recent",
    RemoveFromSuggestions: "Remove from suggestions",
    RenameOnly: "Rename",
    Rename: "Auto Rename",
    RenameTextFileOption: "You have file names that already exist in this folder. Please specify an option.",
    ReplaceOnly: "Replace",
    Replace: "Replace/version",
    ReplaceFile: "Replace file",
    ReplacementFileRequired: "Replacement file required.",
    ReplacementFileRequiredMessage: "Please select a replacement file from the list of available files or by browsing for a file.",
    ReplyTo: "Reply to",
    RequestAccess: "Request access",
    Requester: "Requester",
    Required: "Required",
    Reset: "Reset",
    Restoring: "Restoring",
    RetrievingFolders: "Retrieving folders",
    RetrievingFoldersAndFiles: "Retrieving files and folders",
    RetrievingInfo: "Retrieving information",
    RetryAfter: "Please try again after a few minutes",
    RequestTrial: "Request a free trial",
    RequestTrialText: "With our trial version you can try Docubird for free. For Docubird to function properly, it is important to know how you have implemented SharePoint and Teams.",
    Save: "Save",
    SaveAll: "Save all",
    SaveAsPDFQuestion: "Save as PDF?",
    SaveInProgress: "Saving...",
    SaveProperties: "Save properties",
    SavingDisabled: "Saving disabled",
    SavingFile: "Saving file",
    SavingFiles: "Saving files",
    SavingFilesNotAllowed: "Saving files to this location is not allowed",
    SaveAsPdf: "Save as pdf",
    SaveMail: "Save this mail?",
    SaveOnSend: "Save on send",
    SaveSelection: "Save selection",
    SaveSelected: "Save selected email(s)",
    SaveSelectedFiles: "Save selected files",
    SaveEntireFolder: "Save entire folder",
    SaveEmails: "Save email(s)",
    SaveEmailsConfirmBody: "After clicking the \"OK\" button, you will be redirected to the home screen to choose a location where you want to save the emails.",
    SaveTo: "Save to ",
    SaveToAnotherLocation: "Save to another location",
    Search: "Search",
    SearchDescription: "Search for a specific site",
    SearchFields: "Search fields",
    SearchResults: "Search Results",
    SearchResultsRetrieval: "Retrieving search results...",
    SearchSectionFilter: "Search {section} filters",
    SearchingContent: "Searching content...",
    SearchingFor: "I'm searching for...",
    Select: "Select",
    SelectAFile: "Select a file",
    Selected: "Selected",
    SelectedFile: "Selected file",
    SelectAction: "Select action",
    SelectDestinationDirectory: "Please select a destination directory.",
    SelectDestinationDirectoryConfirmCopy: "Are you sure you want to copy {amount} items from {source} to the current directory?",
    SelectDestinationDirectoryConfirmMove: "Are you sure you want to move {amount} items from {source} to the current directory?",
    SelectItemsToSave: "Select items to save",
    SelectOption: "Select an option",
    SelectSaveLocation: "Select a location to save",
    SelectSensitivityLabel: "Select a sensitivity label",
    SelectSpecificDates: "Select specific dates",
    SelectTerm: "Select term",
    Send: "Send",
    Sending: "Sending",
    SendInMessage: "Send In Message",
    Sensitivity: "Sensitivity",
    Share: "Share",
    Shared: "Shared",
    SharedBy: "Shared by",
    ShareWith: "Share with",
    SharedWith: "Shared with",
    SharedThisItem: "Shared this item",
    SharedItemsShownHere: "Files shared with you will be shown here.",
    SharedMailboxes: "Shared mailboxes",
    SharepointDocumentLibrary: "SharePoint Document Library",
    SharePointDocumentSet: "SharePoint Document set",
    SharepointFolder: "SharePoint Folder",
    SharePointHubSite: "SharePoint Hub Site",
    SharepointSite: "SharePoint Site",
    SharepointSubsite: "SharePoint Subsite",
    ShowDateRangeSlider: "Show date range slider",
    ShowLess: "Show less",
    ShowMore: "Show more",
    ShowPinned: "Show pinned",
    ShowPreview: "Show preview",
    ShowRecent: "Show recent",
    ShowShared: "Show shared",
    SigningIn: "Signing in ...",
    SigningRequest: "Signing request",
    SignInWithDifferentAccount: "Sign in with a different account",
    SigningRequestCreated: "Signing request created",
    SigningRequestError: "Signing request failed",
    SitePermissions: "Site Permissions",
    Sites: "Sites",
    SitesFollowedShownHere: "Sites you follow will be shown here.",
    Size: "Size",
    SmallestOnTop: "Smallest on top",
    SortBy: "Sort by",
    SortOrder: "Sort order",
    Status: "Status",
    Subject: "Subject",
    SubmitForApproval: "Submit for approval",
    Subsites: "Subsites",
    Success: "Success",
    SuggestedContacts: "Suggested contacts",
    SuggestedPeople: "Suggested people",
    SuggestedValues: "Suggested values",
    Suggestions: "Suggestions",
    SuggestedItemsShownHere: "Suggested locations will be shown here.",
    TaxonomyPickerNoTerms: "Term set does not contain any terms",
    TaxonomyPickerExpandTitle: "Expand this Term Set",
    TaxonomyPickerMenuTermSet: "Menu for Term Set",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerTermSetLabel: "Term Set",
    TaxonomyPickerTermsNotFound: "The next selected term(s) could not be found in the term store: {0}",
    TaxonomyPickerInvalidTerms: "Invalid term(s): {0}",
    TeamsChannel: "Teams Channel",
    TeamsChannelNotLoaded: "This channel's files location has not yet been provisioned.",
    TeamsFolder: "Teams Folder",
    TeamsSite: "Teams Site",
    Title: "Title",
    TitleAutoSet: "[Autoset to email subject / filename]",
    To: "To",
    Trending: "Trending",
    TrialExpiredText: "Your free 30-day trial has expired. Would you like to continue using Docubird?",
    Type: "Type",
    UnableToAttach: "Unable to attach email attachments!",
    UnableToAttachTryAgain: "Unable to attach email attachments! Please try again!",
    UnableToAppendLinkTryAgain: "Unable to attach a shareable link! Please try again!",
    UnableToRetrieveFile: "Unable to retrieve the current file! Please try again!",
    UnableToRetrieveTeams: "We were unable to retrieve your team sites",
    Unassigned: "Unassigned",
    Unknown: "Unknown",
    UnpinFile: "Unpin this file",
    UnpinFolder: "Unpin this location",
    Unpublish: "Unpublish",
    UpdateIndividualFile: "Update individual file",
    UpdateIndividualFileMetaData: "Update individual file properties",
    Upload: "Upload",
    UploadCompletedSuccessfully: "Upload completed successfully",
    UploadFiles: "Upload Files",
    UsersAddError: "There was an error adding one or more users",
    UserChangingRole: "Changing user role",
    UserRemove: "Removing user",
    ValuesNotFound: "values not found",
    VerifyingFiles: "Verifying files",
    Views: "Views",
    ViewPendingApprovalsWindow: "View all pending approvals in separate window.",
    Version: "Version",
    VersionHistory: "Version history",
    VersionMinorDraft: "Minor version (draft)",
    VersionMinorOverwrite: "Overwrite the current minor version",
    VersionMajorPublished: "Major version (published)",
    VersionsDeleteAll: "Delete all versions",
    VersionsDeleteMinors: "Delete minor versions",
    VersionDelete: "Delete",
    VersionRestore: "Restore",
    VersionConfirmDeleteAllMessage: "Are you sure you want to delete all versions?",
    VersionConfirmDeleteAllMinorMessage: "Are you sure you want to delete all minor versions?",
    VersionStatusApproved: "Approved - This item will become visible to all users",
    VersionStatusRejected: "Rejected - This item will be returned to its creator only",
    VersionStatusPending: "Pending - This item will remain visible to its creator and all users who can see draft items",
    VersionView: "View",
    Welcome: "Welcome",
    WelcomeLoginText: "Sign in to Microsoft 365",
    WelcomeText: "Docubird is an Microsoft 365 add-in for streamlining document management in SharePoint, OneDrive and Teams.",
    WrongUserPermissionsSave: "You don't have the required permissions to save files to this location.",
    WrongUserPermissionsUpdate: "You don't have the required permissions to update files in this location.",
    Yes: "Yes",
    You: "You"
  },
  nl: {
    Account: "Account",
    AccountDeactivated: "Account voor {placeholder} is gedeactiveerd. Neem contact op met uw beheerder voor assistentie.",
    AccessDenied: "Toegang geweigerd",
    AccessRevoked: "Uw toegang tot {placeholder} is ingetrokken",
    ActionFailed: "Actie mislukt. Probeer het later nog eens.",
    ActionSucceed: "Actie geslaagd!",
    AddAttachment: "Als bijlagen",
    Add: "Toevoegen",
    AddEmail: "Toevoegen aan e-mail",
    AddFiles: "Bestanden toevoegen",
    AddFilesAdditional: "Extra bestanden toevoegen",
    AddShareableLink: "Als links",
    AdvancedSearch: "Geavanceerd zoeken",
    All: "Alle",
    AllAlt: "Alles",
    AllowApprovals: "Mijn goedkeuringen inschakelen",
    AllowApprovalsMessage: "Schakel Docubird in om toegang te krijgen tot uw goedkeuringsinformatie.",
    AlreadyAssigned: "Al toegewezen aan deze goedkeuring",
    AlreadyExists: "Bestaat al",
    App: "app",
    Apply: "Toepassen",
    Approval: "Goedkeuring",
    ApprovalCenter: "Taken",
    ApprovalRequestNotAllowedOwner: "Het goedkeuringsverzoek mag niet opnieuw worden toegewezen aan de goedkeuringseigenaar.",
    ApprovalsLoading: "Goedkeuringen laden...",
    ApprovalsShownHere: "Goedkeuringen worden hier getoond.",
    Approvers: "Goedkeurders",
    Approve: "Goedkeuren",
    Ascending: "Oplopend",
    AsPdf: "als pdf",
    Attachments: "Bijlagen",
    AttachmentsSelected: "geselecteerde bijlagen",
    AttentionSaveModeActive: "Let op: u bevindt zich nog steeds in de email opslaan modus!",
    AutoFolderCreationNoContent: "Gebruik het zoekveld hierboven om naar bestanden en mappen te zoeken.",
    Automation: "Automatisering",
    AutomationFlowDescription: "Automatiseringsprocesbeschrijving",
    AutomationFlowName: "Automatiseringsprocesnaam",
    AutomationFlowNotSelected: "Geen automatiseringsproces geselecteerd",
    AutomationFlowRequest: "Automatiseringsproces aanvraag",
    AutomationFlowRequestError: "Automatiseringsverzoek is mislukt",
    AutomationFlowRequestSuccess: "Automatiseringsverzoek succesvol verzonden",
    AutoOpenDocubird: "Docubird automatisch openen voor dit document?",
    AutoSelectAttachments: "Bijlagen automatisch selecteren",
    AutoRemoveMailItemAttachments: "Verwijder bijlagen van e-mailitem bij opslaan",
    AutoSetEmailProperty: "[Autoset naar e-mail eigenschap '{emailProperty}']",
    AvailableFiles: "Beschikbare bestanden",
    Back: "Terug",
    BackToWork: "Ga weer aan het werk",
    Bcc: "Bcc",
    BlockDownload: "Blok downloaden",
    Browser: "browser",
    By: "door",
    CanEditMakesChanges: "Kan bewerken - Wijzigingen aanbrengen",
    CanViewCannotMakeChanges: "Kan bekijken - Kan geen wijzigingen aanbrengen",
    Cancel: "Annuleer",
    CancelApproval: "Goedkeuring annuleren",
    CancelAssignment: "Opdracht annuleren",
    CancelAssignmentConfrimMessage: "Weet je zeker dat je de opdracht wilt annuleren?",
    Categories: "Categorieën",
    Cc: "Cc",
    Channels: "Kanalen",
    CheckIn: "Check in",
    CheckOut: "Uitchecken",
    CheckedOutBy: "Uitgecheckt door",
    CheckedOutByYou: "Je hebt dit item uitgecheckt",
    ChooseVersion: "Versie kiezen",
    Clear: "Wis",
    ClearSearch: "Zoekactie verwijderen",
    ClearFilter: "Filter wissen",
    Close: "Sluiten",
    Comment: "Commentaar",
    Confirm: "Bevestig",
    ConfirmPublish: "Wil je publiceren?",
    ConfirmDeleteMailbox: "Weet u zeker dat u {mailbox} wilt verwijderen?",
    ContactAdministrator: "Neem contact op met uw beheerder voor assistentie.",
    ContactUs: "Neem gerust contact met ons op voor een passende offerte.",
    ContentManager: "Inhoudsbeheer",
    ContentType: "Inhoudstype",
    ContentTypes: "Inhoudstypen",
    Continue: "Doorgaan",
    ConversationIndex: "Conversatie-index",
    ConversationTopic: "Conversatie-onderwerp",
    ConvertEmailToPdf: 'E-mail converteren naar pdf bij opslaan',
    ConvertToPdf: 'Converteren naar PDF',
    CopyItems: "Kopie items",
    CopyingItems: "Items kopiëren...",
    CopyProgress: "Kopieer vooruitgang",
    CopyProgressCounter: "{completed} van {total} items gekopieerd",
    CopyAll: "Alles kopiëren",
    CopyTo: "Kopie naar",
    Create: "Aanmaken",
    Created: "Aangemaakt",
    CreateWithAttachments: "Met bijlagen",
    CreateWithShareableLinks: "Met links",
    CreateEmail: "Maak een nieuwe e-mail",
    CreateEmailWithAttachment: "Maak een e-mail met bijlage",
    CreateEmailWithLink: "Maak een e-mail met een link",
    Datasource: "databron",
    Date: "Datum",
    Default: "Standaard",
    Delete: "Verwijderen",
    Deleting: "Verwijderen",
    DeleteSPItemConfirmMessage: "Weet je zeker dat je dit item(s) naar de prullenbak van de site wilt sturen?",
    Descending: "Aflopend",
    Description: "Omschrijving",
    Details: "Details",
    DiscardCheckOut: "Uitchecken weggooien",
    Disconnect: "Afmelden",
    DocumentLibraries: "Documentbibliotheken",
    DocumentLibrary: "Documentbibliotheek",
    DocumentSettings: "Document-instellingen",
    DocumentSharedWithYouBy: "Dit is het document dat [person] met u heeft gedeeld.",
    DocumentSharedWithYouByEmailSubject: "[person] heeft \"[file_name]\" met je gedeeld.",
    DocumentShareSuccess: "\"[file_name]\" succesvol gedeeld",
    Done: "Klaar",
    Download: "Download",
    Downloading: "Downloaden",
    DownloadAsPdf: "Download als pdf",
    DownloadAsPdfFailure: "Kan het bestand niet omzetten naar pdf-formaat. Het bestand kan een verkeerd formaat hebben, te groot, of mogelijk corrupt zijn.",
    DownloadFailure: "Download mislukt",
    DownloadingAttachments: "Bijlagen downloaden",
    DoYouWantToCreateFolder: "Wilt u de e-mails opslaan in een nieuwe map?",
    Draft: "Concept",
    DueDate: "Vervaldatum",
    DueDateDescription: "Standaard {days} dagen.",
    DuplicateResolved: "Uw dubbele bestandsnamen zijn opgelost. U kunt doorgaan met opslaan!",
    EditXItems: "Bewerk {itemCount} items",
    EmailHeaderMapping: "Toewijzing van e-mailheaders",
    Emails: "E-mails",
    Empty: "Leeg",
    EnableEmails: "E-mails inschakelen",
    EnterDate: "Vul een datum in",
    EnterEmail: "Voer namen, e-mails of gebruikersgroepen in",
    EnterFolderName: "Voer een mapnaam in",
    EntireFolderSelected: "Gehele map geselecteerd",
    Error: "Fout",
    ErrorMessageGeneric: "Er is iets fout gegaan",
    ErrorDeletingFiles: "Er is een fout opgetreden bij het verwijderen van een of meer bestanden",
    ErrorConnectingToServer: "Fout bij het verbinden met de server",
    ErrorWhileUpdatingMetadata: "Er is een fout opgetreden bij het updaten van uw metadata",
    ExchangeSettings: "Exchange-instellingen",
    FetchProgressCounter: "{total} items opgehaald",
    FetchProgressCounterAll: "Alle items ophalen...",
    FieldRequired: "Veld is verplicht",
    FileBackgroundSave: "Uw bestanden worden op de achtergrond opgeslagen...",
    FileBackgroundSaveFailure: "Er is iets fout gegaan",
    FilesNotSuccessfullyUploaded: "De volgende bestanden zijn niet succesvol geüpload",
    FileDeleted: "Bestand verwijderd",
    FileInfo: "Bestandsinformatie",
    FileLocationError: "Kan bestandslocatie niet openen.",
    FileLocationUnknown: "Bestandslocatie onbekend",
    FileNotFound: "Bestand niet gevonden",
    FileRecentlyDeleted: "Het bestand is onlangs verwijderd en is niet meer beschikbaar",
    FileNotExist: "Bestand bestaat niet meer!",
    FileNotSaved: "Zorg ervoor dat uw bestand lokaal is opgeslagen",
    FileSelected: "Bestand geselecteerd",
    FilesSelected: "Bestanden geselecteerd",
    FilesSelectedToUpload: "geselecteerde bestand(en) om te uploaden",
    Files: "Bestanden",
    FileSaveSuccess: "Uw bestanden zijn succesvol opgeslagen",
    FileSaveSuccessSingle: "Bestand succesvol opgeslagen",
    FileSameCheckedOut: "Een bestand met deze naam is al uitgecheckt",
    FileCurrentlyCheckedOut: "Dit bestand is momenteel uitgecheckt",
    FileSameLocked: "Een bestand met deze naam is vergrendeld",
    FileSameName: "Er bestaat al een bestand met deze naam",
    FileVersionLimitReached: "Limiet voor bestandsversie bereikt",
    Filter: "Filter",
    FilterDateStepSince: "Sinds",
    FilterDateStepLast3Months: "In de afgelopen 3 maanden",
    FilterDateStepLast30Days: "In de afgelopen 30 dagen",
    FilterDateStepLast7Days: "In de afgelopen 7 dagen",
    FilterDateStepSinceYesterday: "Sinds gisteren",
    FilterDateStepToday: "Vandaag",
    FilterDateStepTomorrow: "Morgen",
    FilterDateStepIn7Days: "Over 7 dagen",
    FilterDateStepIn30Days: "Over 30 dagen",
    FilterDateStepIn3Months: "Over 3 maanden",
    FilterDateStepInAYearOrMore: "Over een jaar of langer",
    FilterDateStepIn3MonthsOrMore: "Over 3 maanden of langer",
    FilterResults: "Filter resultaten",
    Finished: "Helemaal klaar",
    FolderNotExist: "Map bestaat niet meer!",
    Folder: "Map",
    Folders: "Mappen",
    FolderCreate: "Nieuwe map",
    FolderCreateSuccess: "De map is succesvol aangemaakt",
    FolderDeleted: "Map verwijderd",
    FolderName: "Mapnaam",
    FolderRecentlyDeleted: "De map is onlangs verwijderd en is niet meer beschikbaar",
    FolderSameName: "Er bestaat al een map met deze naam",
    FolderSameNameAutoRename: "Er bestaat al een map of mappen met dezelfde naam. De geüploade map(pen) krijgt (krijgen) bij het uploaden automatisch een andere naam.",
    FolderType: "Maptype",
    FollowedSites: "Gevolgde sites",
    From: "Van",
    GenericNoResultsFoundText: "Geen resultaten gevonden",
    Group: "Groep",
    HidePreview: "Verberg voorbeeld",
    History: "Geschiedenis",
    Home: "Huis",
    HubAssociatedHubs: "Bijbehorende hubsites",
    HubAssociatedSites: "Bijbehorende sites",
    HubSite: "Hubsite",
    IndividualFilesUpdated: "Individuele bestanden bijgewerkt",
    Importance: "Belangrijkheid",
    InReplyTo: "Als antwoord op",
    InsertAsAttachment: "Invoegen als bijlage",
    InsertAsLink: "Invoegen als link",
    InsertFrom: "Invoegen vanaf",
    InvalidEmail: "Ongeldige e-mail",
    Item: "Item",
    Items: "Items",
    ItemsToAddAsAttachmentsLinks: "Items om toe te voegen als {placeholder}",
    ItemToCopy: "Item om te kopiëren",
    ItemsToCopy: "Items om te kopiëren",
    ItemToMove: "Item om te verplaatsen",
    ItemsToMove: "Items om te verplaatsen",
    ItemsSelected: "items geselecteerd",
    LandingPage: "Landingspagina",
    LargestOnTop: "Grootste bovenaan",
    LeastRelevantOnTop: "Minst relevante bovenaan",
    LevelUp: "Niveau omhoog",
    LibraryPermissions: "Bibliotheekmachtigingen",
    LicenseRequired: "Om toegang te krijgen tot {placeholder} moet u een betaalde licentie hebben.",
    LicenseRequiredTitle: "Licentie vereist",
    LimitReached: "Limiet bereikt",
    Link: "Link",
    ListItemPickerSelectValue: "Selecteer waarde",
    List: "Lijst",
    Lists: "Lijsten",
    ListItem: "Lijstitem",
    Loading: "Laden ...",
    LoadingOnly: "Laden",
    LoadingFilters: "Filters laden",
    LoadingInputs: "Laad meer resultaten",
    LoadingProfile: "Profiel laden ...",
    LoadDefaults: "Laad standaardinstellingen",
    LoadMore: "Laad meer resultaten",
    LoadingEmails: "E-mails laden",
    Local: "lokaal",
    Location: "Locatie",
    Locations: "Microsoft 365 locaties",
    MailboxAddress: "Mailbox adres",
    MailboxAuthorizing: "Mailbox machtigen",
    MailboxAlreadyAdded: "Mailbox reeds toegevoegd",
    Manage: "Beheren",
    MaximumEmailMessagesSelected: "Er kunnen maximaal {amount} e-mailberichten tegelijk worden opgeslagen.",
    Me: "Ik",
    Member: "Lid",
    Members: "Leden",
    MembersAdd: "Leden toevoegen",
    MemberSelect: "Selecteer lid",
    MembersNotSelected: "Geen leden geselecteerd",
    MembersNotFound: "Geen lede gevind nie",
    MessageId: "Bericht-ID",
    Message: "Bericht",
    MetadataNotUpdated: "Bestanden zijn succesvol opgeslagen. Zorg ervoor dat de metagegevens dienovereenkomstig zijn bijgewerkt",
    MetadataValidationFailed: "Validatie mislukt voor",
    MinorVersions: "Secundaire(concept) versies",
    Modified: "Aangepast",
    ModifiedBy: "Aangepast door",
    More: "Meer",
    MoreActions: "Toon acties",
    MostRelevantOnTop: "Most relevant on top",
    MoveItems: "Verplaatsen items",
    MovingItems: "Items verplaatsen...",
    MoveItemUp: "Verplaats het vastgezette item naar boven",
    MoveItemDown: "Verplaats het vastgezette item naar beneden",
    MoveProgress: "Verplaatsen vooruitgang",
    MoveProgressCounter: "{completed} van {total} items verplaatst",
    MoveAll: "Alles verplaatsen",
    MoveTo: "Verplaatsen naar",
    MyApprovals: "Mijn goedkeuringen",
    Name: "Naam",
    New: "Nieuwe",
    NewestOnTop: "Nieuwste bovenaan",
    NewOnly: "Nieuw",
    No: "Nee",
    NoAppSpecificFiles: "No {context}-bestanden gevonden.",
    NoEmailAvailable: "Geen e-mail beschikbaar",
    NoFiltersAvailable: "Geen filters beschikbaar",
    NoFilesSelected: "Geen bestanden geselecteerd",
    NoItemsFound: "Geen items gevonden!",
    NoMoreFolders: "Er bevinden zich geen mappen in deze map!",
    NoMoreFoldersAndFiles: "Deze map is leeg.",
    NoLocations: "Geen verdere locaties",
    NotAssignedToTeam: "U bent geen lid van een team.",
    NotAssignedToSite: "U bent geen lid van een site.",
    NoResultsFound: "geen onderwerp",
    NoSubject: "No subject",
    NotWorkingOnOnlineVersion: "U werkt niet aan de online versie van dit document.",
    Of: "van",
    Ok: "Ok",
    OldestOnTop: "Oudste bovenaan",
    OneDrive: "Een schijf",
    OneOrMoreFilesLockedCheckedOut: "Een of meer bestanden vergrendeld/uitgecheckt",
    Open: "Open",
    OpenFileInBrowser: "Open bestand in browser",
    OpenFileLocation: "Bestandslocatie openen",
    OpenFileLocationIn: "Bestandslocatie openen in",
    OpenIn: "Openen in",
    OpenFolder: "Map openen",
    OpenOnlineDocumentWith: "Open het document in",
    OpenFolderInBrowser: "Open locatie in browser",
    OptionalComment: "Voeg een opmerking toe (optioneel)",
    Options: "Opties",
    OriginalSubject: "Origineel onderwerp",
    Overview: "Overzicht",
    OutlookSettings: "Outlook-instellingen",
    Overwrite: "Bestaande bestanden overschrijven/versieren",
    OverwriteRequired: "Wijzig de conflicterende bestandsnaam(en) of kies de optie om bestaande bestanden te overschrijven/versieren.",
    Owner: "Eigenaar",
    Participants: "Deelnemers",
    Permissions: "Rechten",
    Pinned: "Vastgemaakt",
    PinnedItemsShownHere: "Vastgezette items worden hier getoond.",
    PinThisFile: "Pin dit bestand",
    PinThisFolder: "Pin deze locatie",
    PleaseSelectSomeoneShare: "Selecteer iemand om mee te delen",
    PriceLinkText: "Onze prijzen kunt u hier bekijken.",
    PrivacySensitiveChecking: "Controleren op privacygevoelige gegevens",
    PrivacySensitiveCheckError: "Fout bij controleren op privacygevoelige gegevens",
    PrivacySensitiveDisplay: "Privacygevoelig",
    PrivacySensitiveDataFound: "Privacygevoelige gegevens gevonden",
    PrivacySensitiveDataNotFound: "Geen privacygevoelige gegevens gevonden",
    PrivacySensitiveDataNotChecked: "Privacygevoelige gegevens niet aangevinkt",
    PrivacySensitiveRedact: "Privacygevoelige gegevens redigeren",
    Private: "Privaat",
    Preferences: "Voorkeuren",
    PreparingCopy: "Kopiëren voorbereiden...",
    PreparingMove: "Verplaatsing voorbereiden...",
    Properties: "Eigenschappen",
    Publish: "Publiceren",
    PublishedMajorVersion: "Huidige gepubliceerde primaire versie",
    QuickAccess: "Snelle toegang",
    ReadMore: "Lees Meer...",
    ReadOnly: "Alleen-lezen",
    Reason: "Reden",
    Reassign: "Opnieuw toewijzen",
    ReassignTo: "Opnieuw toewijzen aan",
    Recipients: "Ontvangers",
    Received: "Ontvangen",
    Recent: "Recent",
    RecentlyEditYou: "Je hebt dit onlangs bewerkt",
    RecentlyOpened: "Onlangs geopend",
    RecentlyOpenedYou: "Je hebt dit onlangs geopend",
    RecentItemsShownHere: "Recente items worden hier getoond.",
    Recheck: "Opnieuw controleren",
    Recommended: "Aanbevolen",
    Redact: "Redigeren",
    References: "Referenties",
    Refresh: "Vernieuwen",
    Reject: "Afwijzen",
    Relevance: "Relevantie",
    Remove: "Verwijderen",
    RemoveFromRecent: "Verwijderen uit recent",
    RemoveFromSuggestions: "Verwijderen uit suggesties",
    RenameOnly: "Hernoemen",
    Rename: "Automatisch hernoemen",
    RenameTextFileOption: "Je hebt bestandsnamen die al in deze map staan. Specificeer een optie.",
    ReplaceOnly: "Vervangen",
    Replace: "Vervangen",
    ReplaceFile: "Bestand vervangen",
    ReplacementFileRequired: "Vervangend bestand vereist.",
    ReplacementFileRequiredMessage: "Selecteer een vervangend bestand uit de lijst met beschikbare bestanden of door naar een bestand te bladeren.",
    ReplyTo: "Antwoord aan",
    RequestAccess: "Toegang aanvragen",
    Requester: "Aanvrager",
    Required: "Vereist",
    Reset: "Annuleren",
    Restoring: "Herstellen",
    RetrievingFolders: "Mappen ophalen",
    RetrievingFoldersAndFiles: "Ophalen van bestanden en mappen",
    RetrievingInfo: "Informatie ophalen",
    RetryAfter: "Probeer het opnieuw na een paar minuten",
    RequestTrial: "Vraag een gratis proefversie aan",
    RequestTrialText: "Met onze proefversie kunt u Docubird gratis uitproberen. Voor een goede werking van Docubird is het belangrijk te weten hoe u SharePoint en Teams heeft geïmplementeerd.",
    Save: "Opslaan",
    SaveAll: "Alles opslaan",
    SaveAsPDFQuestion: "Opslaan als PDF?",
    SaveInProgress: "Bezig met opslaan ...",
    SaveProperties: "Eigenschappen opslaan",
    SavingDisabled: "Opslaan uitgeschakeld",
    SavingFile: "Bestand opslaan",
    SavingFiles: "Bestanden opslaan",
    SavingFilesNotAllowed: "Het opslaan van bestanden op deze locatie is niet toegestaan",
    SaveAsPdf: "Opslaan als pdf",
    SaveMail: "Deze mail opslaan?",
    SaveOnSend: "Opslaan na sturen",
    SaveSelection: "Selectie opslaan",
    SaveSelected: "Geselecteerde e-mail(s) opslaan",
    SaveSelectedFiles: "Geselecteerde bestanden opslaan",
    SaveEntireFolder: "Gehele map opslaan",
    SaveEmails: "E-mail(s) opslaan",
    SaveEmailsConfirmBody: "Na het klikken op de \"OK\" knop, wordt u doorverwezen naar het startscherm om een locatie te kiezen waar u de e-mails wilt opslaan.",
    SaveTo: "Opslaan naar ",
    SaveToAnotherLocation: "Opslaan op een andere locatie",
    Search: "Zoeken",
    SearchDescription: "Zoeken naar een specifieke site",
    SearchFields: "Zoekvelden",
    SearchResults: "Zoekresultaten",
    SearchResultsRetrieval: "Zoekresultaten ophalen ...",
    SearchSectionFilter: "Zoek {section} filters",
    SearchingContent: "Zoeken naar inhoud...",
    SearchingFor: "Ik ben op zoek naar",
    Select: "Selecteer",
    SelectAFile: "Selecteer een bestand",
    Selected: "Geselecteerd",
    SelectedFile: "Geselecteerd bestand",
    SelectAction: "Selecteer actie",
    SelectDestinationDirectory: "Kies een doelmap.",
    SelectDestinationDirectoryConfirmCopy: "Weet u zeker dat u {amount} items van {source} wilt kopiëren naar de huidige map?",
    SelectDestinationDirectoryConfirmMove: "Weet u zeker dat u {amount} items van {source} naar de huidige map wilt verplaatsen?",
    SelectItemsToSave: "Selecteer items om op te slaan",
    SelectOption: "Kies een optie",
    SelectSaveLocation: "Selecteer een opslaglocatie",
    SelectSensitivityLabel: "Selecteer een gevoeligheidslabel",
    SelectSpecificDates: "Specifieke datums selecteren",
    SelectTerm: "Selecteer term",
    Send: "Versturen",
    Sending: "Bezig met verzenden",
    SendInMessage: "Bericht verzenden",
    Sensitivity: "Gevoeligheid",
    Share: "Delen",
    Shared: "Delen",
    SharedBy: "Gedeeld door",
    ShareWith: "Delen met",
    SharedWith: "Gedeeld met",
    SharedThisItem: "hebt dit item gedeeld",
    SharedItemsShownHere: "Gedeelde items verschijnen hier.",
    SharedMailboxes: "Gedeelde mailboxen",
    SharepointDocumentLibrary: "SharePoint-documentbibliotheek",
    SharePointDocumentSet: "SharePoint-documentenset",
    SharepointFolder: "SharePoint-map",
    SharePointHubSite: "SharePoint-hubsite",
    SharepointSite: "SharePoint-site",
    SharepointSubsite: "SharePoint-subsite",
    ShowDateRangeSlider: "Toon datumbereik schuif",
    ShowLess: "Laat minder zien",
    ShowMore: "Laat meer zien",
    ShowPinned: "Toon vastgemaakt",
    ShowPreview: "Toon voorbeeld",
    ShowRecent: "Toon recent",
    ShowShared: "Toon delen",
    SigningIn: "Inloggen ...",
    SigningRequest: "Ondertekenverzoek",
    SignInWithDifferentAccount: "Login met een ander account",
    SigningRequestCreated: "Ondertekenverzoek aangemaakt",
    SigningRequestError: "Ondertekenverzoek misluktd",
    SitePermissions: "Sitemachtigingen",
    Sites: "Sites",
    SitesFollowedShownHere: "Sites die u volgt worden hier getoond.",
    Size: "Groote",
    SmallestOnTop: "Kleinste bovenaan",
    SortBy: "Sorteren op",
    SortOrder: "Sorteervolgorde",
    Status: "Toestand",
    Subject: "Onderwerp",
    SubmitForApproval: "Indienen voor goedkeuring",
    Subsites: "Subsites",
    Success: "Succes",
    SuggestedContacts: "Voorgestelde contacten",
    SuggestedPeople: "Voorgestelde mensen",
    SuggestedValues: "Voorgestelde waarden",
    Suggestions: "Suggesties",
    SuggestedItemsShownHere: "Voorgestelde locaties worden hier getoond.",
    TaxonomyPickerNoTerms: "Termenset bevat geen termen",
    TaxonomyPickerExpandTitle: "Vouw deze termenset uit",
    TaxonomyPickerMenuTermSet: "Menu voor Term Set",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerTermSetLabel: "Termijn ingesteld",
    TaxonomyPickerTermsNotFound: "De volgende geselecteerde term (en) zijn niet gevonden in de term store: {0}",
    TaxonomyPickerInvalidTerms: "Ongeldige term(en): {0}",
    TeamsChannel: "Teams-kanaal",
    TeamsChannelNotLoaded: "De bestandslocatie van dit kanaal is nog niet ingericht.",
    TeamsFolder: "Teams-map",
    TeamsSite: "Teams-site",
    Title: "Titel",
    TitleAutoSet: "[Automatisch ingesteld op onderwerp / bestandsnaam]",
    To: "Aan",
    Trending: "Trending",
    TrialExpiredText: "Uw gratis proefperiode van 30 dagen is verlopen. Wilt u Docubird blijven gebruiken?",
    Type: "Type",
    UnableToAttach: "E-mailbijlagen kunnen niet worden bijgevoegd!",
    UnableToAttachTryAgain: "E-mailbijlagen kunnen niet worden bijgevoegd! Probeer het a.u.b. opnieuw!",
    UnableToAppendLinkTryAgain: "Kan geen deelbare link bijvoegen! Probeer het a.u.b. opnieuw!",
    UnableToRetrieveFile: "Kan het huidige bestand niet ophalen! Probeer het a.u.b. opnieuw!",
    UnableToRetrieveTeams: "We kunnen uw teamsites niet ophalen",
    Unassigned: "Niet toegewezen",
    Unknown: "Onbekend",
    UnpinFile: "Unpin dit bestand",
    UnpinFolder: "Unpin deze locatie",
    Unpublish: "Depubliceren",
    UpdateIndividualFile: "Individueel bestand bijwerken",
    UpdateIndividualFileMetaData: "Update individuele bestandseigenschappen",
    Upload: "Uploaden",
    UploadCompletedSuccessfully: "Upload succesvol afgerond",
    UploadFiles: "Upload bestanden",
    UsersAddError: "Er is een fout opgetreden bij het toevoegen van een of meer gebruikers",
    UserChangingRole: "Gebruikersrol wijzigen",
    UserRemove: "Gebruiker verwijderen",
    ValuesNotFound: "waarden niet gevonden",
    VerifyingFiles: "Bestanden verifiëren",
    Views: "Weergave",
    ViewPendingApprovalsWindow: "Bekijk alle lopende goedkeuringen in een apart venster.",
    Version: "Versie",
    VersionHistory: "Versie geschiedenis",
    VersionMinorDraft: "Secundaire versie (concept)",
    VersionMinorOverwrite: "Overschrijf de huidige secundaire versie",
    VersionMajorPublished: "Primaire versie (gepubliceerd)",
    VersionsDeleteAll: "Alle versies verwijderen",
    VersionsDeleteMinors: "Secundaire versies verwijderen",
    VersionDelete: "Verwijderen",
    VersionRestore: "Herstellen",
    VersionConfirmDeleteAllMessage: "Weet u zeker dat u alle versies wilt verwijderen?",
    VersionConfirmDeleteAllMinorMessage: "Weet u zeker dat u alle secundaire versies wilt verwijderen?",
    VersionStatusApproved: "Goedgekeurd - Dit item wordt zichtbaar voor alle gebruikers",
    VersionStatusRejected: "Afgewezen - Dit item wordt alleen teruggestuurd naar de maker",
    VersionStatusPending: "In behandeling - Dit item blijft zichtbaar voor de maker en alle gebruikers die conceptitems kunnen zien",
    VersionView: "Weergave",
    Welcome: "Welkom",
    WelcomeLoginText: "Meld u aan bij Microsoft 365",
    WelcomeText: "Docubird is een Microsoft 365 add-in voor het stroomlijnen van document management in SharePoint, OneDrive en Teams.",
    WrongUserPermissionsSave: "Je hebt niet de vereiste rechten om bestanden op deze locatie op te slaan.",
    WrongUserPermissionsUpdate: "Je hebt niet de vereiste rechten om bestanden op deze locatie bij te werken.",
    Yes: "Ja",
    You: "U"
  },
  de: {
    Account: "Konto",
    AccountDeactivated: "Konto für {placeholder} wurde deaktiviert. Bitte wenden Sie sich für Unterstützung an Ihren Administrator.",
    AccessDenied: "Zugriff verweigert",
    AccessRevoked: "Ihr Zugang für {placeholder} wurde widerrufen",
    ActionFailed: "Aktion fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    ActionSucceed: "Aktion erfolgreich!",
    AddAttachment: "Als Anhänge",
    Add: "Hinzufügen",
    AddEmail: "Zur E-Mail hinzufügen",
    AddFiles: "Dateien hinzufügen",
    AddFilesAdditional: "Zusätzliche Dateien hinzufügen",
    AddShareableLink: "Als Links",
    AdvancedSearch: "Erweiterte Suche",
    All: "Alle",
    AllAlt: "Alle",
    AllowApprovals: "Meine Genehmigungen aktivieren",
    AllowApprovalsMessage: "Ermöglichen Sie Docubird den Zugriff auf Ihre Genehmigungsdaten.",
    AlreadyAssigned: "Bereits für diese Genehmigung zugewiesen",
    AlreadyExists: "Bereits vorhanden",
    App: "app",
    Apply: "Anwenden",
    Approval: "Genehmigung",
    ApprovalCenter: "Aufgaben",
    ApprovalRequestNotAllowedOwner: "Die Genehmigungsanfrage darf nicht an den Genehmigungsinhaber weitergeleitet werden.",
    ApprovalsLoading: "Genehmigungen werden geladen...",
    ApprovalsShownHere: "Genehmigungen werden hier angezeigt.",
    Approvers: "Genehmiger",
    Approve: "Genehmigen",
    Ascending: "Aufsteigend",
    AsPdf: "als PDF",
    Attachments: "Anhänge",
    AttachmentsSelected: "ausgewählte Anhänge",
    AttentionSaveModeActive: "Achtung: bitte beachten Sie, dass Sie noch im E-Mail-Speichermodus sind!",
    AutoFolderCreationNoContent: "Nutzen Sie das Suchfeld oben, um Dokumente und Ordner zu finden.",
    Automation: "Automatisierung",
    AutomationFlowDescription: "Beschreibung des Automatisierungsprozesses",
    AutomationFlowName: "Name des Automatisierungsprozesses",
    AutomationFlowNotSelected: "Kein Automatisierungsprozess ausgewählt",
    AutomationFlowRequest: "Anfrage zum Automatisierungsprozess",
    AutomationFlowRequestError: "Automatisierungsanfrage fehlgeschlagen",
    AutomationFlowRequestSuccess: "Automatisierungsanfrage erfolgreich gesendet",
    AutoOpenDocubird: "Docubird automatisch für dieses Dokument öffnen?",
    AutoSelectAttachments: "Anhänge automatisch auswählen",
    AutoRemoveMailItemAttachments: "Anhänge beim Speichern des E-Mail-Elements entfernen",
    AutoSetEmailProperty: "[Automatisch auf E-Mail-Eigenschaft '{emailProperty}' gesetzt]",
    AvailableFiles: "Verfügbare Dateien",
    Back: "Zurück",
    BackToWork: "Zurück zur Arbeit",
    Bcc: "Bcc",
    BlockDownload: "Download blockieren",
    Browser: "Browser",
    By: "von",
    CanEditMakesChanges: "Kann bearbeiten - Änderungen vornehmen",
    CanViewCannotMakeChanges: "Kann anzeigen - Kann keine Änderungen vornehmen",
    Cancel: "Abbrechen",
    CancelApproval: "Genehmigung abbrechen",
    CancelAssignment: "Aufgabe abbrechen",
    CancelAssignmentConfrimMessage: "Sind Sie sicher, dass Sie die Zuweisung abbrechen möchten?",
    Categories: "Kategorien",
    Cc: "Cc",
    Channels: "Kanäle",
    CheckIn: "Einchecken",
    CheckOut: "Auschecken",
    CheckedOutBy: "Ausgecheckt von",
    CheckedOutByYou: "Sie haben diesen Artikel ausgecheckt",
    ChooseVersion: "Version auswählen",
    Clear: "Löschen",
    ClearSearch: "Suche löschen",
    ClearFilter: "Filter löschen",
    Close: "Schließen",
    Comment: "Kommentar",
    Confirm: "Bestätigen",
    ConfirmPublish: "Möchten Sie veröffentlichen?",
    ConfirmDeleteMailbox: "Sind Sie sicher, dass Sie {mailbox} löschen möchten?",
    ContactAdministrator: "Bitte wenden Sie sich zur Unterstützung an Ihren Administrator.",
    ContactUs: "Bitte zögern Sie nicht, uns für ein passendes Angebot zu kontaktieren.",
    ContentManager: "Content Manager",
    ContentType: "Inhaltstyp",
    ContentTypes: "Inhaltstypen",
    Continue: "Fortsetzen",
    ConversationIndex: "Gesprächsindex",
    ConversationTopic: "Gesprächsthema",
    ConvertEmailToPdf: 'E-Mail beim Speichern in PDF umwandeln',
    ConvertToPdf: 'In PDF konvertieren',
    CopyItems: "Elemente kopieren",
    CopyingItems: "Elemente werden kopiert...",
    CopyProgress: "Kopierfortschritt",
    CopyProgressCounter: "{completed} von {total} Elementen kopiert",
    CopyAll: "Alles kopieren",
    CopyTo: "Kopieren nach",
    Create: "Erstellen",
    Created: "Erstellt",
    CreateWithAttachments: "Mit Anhängen",
    CreateWithShareableLinks: "Mit Links",
    CreateEmail: "E-Mail erstellen",
    CreateEmailWithAttachment: "E-Mail mit Anhang erstellen",
    CreateEmailWithLink: "E-Mail mit Link erstellen",
    Datasource: "Datenquelle",
    Date: "Datum",
    Default: "Standard",
    Delete: "Löschen",
    Deleting: "Wird gelöscht",
    DeleteSPItemConfirmMessage: "Sind Sie sicher, dass Sie diese(n) Artikel in den Papierkorb der Website verschieben möchten?",
    Descending: "Absteigend",
    Description: "Beschreibung",
    Details: "Details",
    DiscardCheckOut: "Auschecken verwerfen",
    Disconnect: "Trennen",
    DocumentLibraries: "Dokumentbibliotheken",
    DocumentLibrary: "Dokumentbibliothek",
    DocumentSettings: "Dokumenteinstellungen",
    DocumentSharedWithYouBy: "Dies ist das Dokument, das [person] mit Ihnen geteilt hat.",
    DocumentSharedWithYouByEmailSubject: "[person] hat \"[file_name]\" mit Ihnen geteilt.",
    DocumentShareSuccess: "\"[file_name]\" erfolgreich geteilt",
    Done: "Fertig",
    Download: "Herunterladen",
    Downloading: "Wird Heruntergeladen",
    DownloadAsPdf: "Als PDF herunterladen",
    DownloadAsPdfFailure: "Die Datei konnte nicht in das PDF-Format konvertiert werden. Möglicherweise ist das Format der Datei falsch, sie ist zu groß oder möglicherweise beschädigt.",
    DownloadFailure: "Fehler beim Herunterladen",
    DownloadingAttachments: "Anhänge herunterladen",
    DoYouWantToCreateFolder: "Möchten Sie die E-Mails in einem neuen Ordner speichern?",
    Draft: "Entwurf",
    DueDate: "Fälligkeitsdatum",
    DueDateDescription: "Standardmäßig {days} Tage.",
    DuplicateResolved: "Ihre doppelten Dateinamen wurden geklärt. Sie können mit dem Speichern fortfahren!",
    EditXItems: "Bearbeiten Sie {itemCount} Elemente",
    EmailHeaderMapping: "Zuordnung von E-Mail-Kopfzeilen",
    Emails: "E-Mails",
    Empty: "Leer",
    EnableEmails: "E-Mails aktivieren",
    EnterDate: "Geben Sie ein Datum ein",
    EnterEmail: "Geben Sie Namen, E-Mails oder Benutzergruppen ein",
    EnterFolderName: "Bitte geben Sie einen Ordnernamen ein",
    EntireFolderSelected: "Ganzer Ordner ausgewählt",
    Error: "Fehler",
    ErrorMessageGeneric: "Etwas ist schief gelaufen",
    ErrorDeletingFiles: "Beim Löschen einer oder mehrerer Dateien ist ein Fehler aufgetreten",
    ErrorWhileUpdatingMetadata: "Beim Aktualisieren Ihrer Metadaten ist ein Fehler aufgetreten",
    ErrorConnectingToServer: "Fehler bei der Verbindung zum Server",
    ExchangeSettings: "Exchange-Einstellungen",
    FetchProgressCounter: "{total} Elemente abgerufen",
    FetchProgressCounterAll: "Alle Artikel abrufen...",
    FieldRequired: "Feld ist erforderlich",
    FileBackgroundSave: "Ihre Dateien werden im Hintergrund gespeichert...",
    FileBackgroundSaveFailure: "Etwas ist schief gelaufen",
    FilesNotSuccessfullyUploaded: "Die folgenden Dateien wurden nicht erfolgreich hochgeladen",
    FileDeleted: "Datei gelöscht",
    FileInfo: "Dateiinformationen",
    FileLocationError: "Dateiort kann nicht geöffnet werden.",
    FileLocationUnknown: "Dateiort unbekannt",
    FileNotFound: "Datei nicht gefunden",
    FileRecentlyDeleted: "Die Datei wurde kürzlich gelöscht und ist nicht mehr verfügbar",
    FileNotExist: "Datei existiert nicht mehr!",
    FileNotSaved: "Bitte stellen Sie sicher, dass Ihre Datei lokal gespeichert wurde!",
    FileSelected: "Datei ausgewählt",
    FilesSelected: "Dateien ausgewählt",
    FilesSelectedToUpload: "Datei(en) zum Hochladen ausgewählt",
    Files: "Dateien",
    FileSaveSuccess: "Ihre Dateien wurden erfolgreich gespeichert",
    FileSaveSuccessSingle: "Datei erfolgreich gespeichert",
    FileSameCheckedOut: "Eine Datei mit diesem Namen ist bereits ausgecheckt",
    FileCurrentlyCheckedOut: "Diese Datei ist derzeit ausgecheckt",
    FileSameLocked: "Eine Datei mit diesem Namen ist gesperrt",
    FileSameName: "Eine Datei mit diesem Namen existiert bereits",
    FileVersionLimitReached: "Dateiversionenlimit erreicht",
    Filter: "Filter",
    FilterDateStepSince: "Seit",
    FilterDateStepLast3Months: "In den letzten 3 Monaten",
    FilterDateStepLast30Days: "In den letzten 30 Tagen",
    FilterDateStepLast7Days: "In den letzten 7 Tagen",
    FilterDateStepSinceYesterday: "Seit gestern",
    FilterDateStepToday: "Heute",
    FilterDateStepTomorrow: "Morgen",
    FilterDateStepIn7Days: "In 7 Tagen",
    FilterDateStepIn30Days: "In 30 Tagen",
    FilterDateStepIn3Months: "In 3 Monaten",
    FilterDateStepInAYearOrMore: "In einem Jahr oder später",
    FilterDateStepIn3MonthsOrMore: "In 3 Monaten oder mehr",
    FilterResults: "Filterergebnisse",
    Finished: "Alles erledigt",
    FolderNotExist: "Ordner existiert nicht mehr!",
    Folder: "Ordner",
    Folders: "Ordner",
    FolderCreate: "Neuen Ordner erstellen",
    FolderCreateSuccess: "Der Ordner wurde erfolgreich erstellt",
    FolderDeleted: "Ordner gelöscht",
    FolderName: "Ordnername",
    FolderRecentlyDeleted: "Der Ordner wurde kürzlich gelöscht und ist nicht mehr verfügbar",
    FolderSameName: "Ein Ordner mit diesem Namen existiert bereits",
    FolderSameNameAutoRename: "Ein oder mehrere Ordner mit dem/den gleichen Namen sind bereits vorhanden. Der/die hochgeladene(n) Ordner wird/werden beim Hochladen automatisch umbenannt.",
    FolderType: "Ordnertyp",
    FollowedSites: "Verfolgte Websites",
    From: "Von",
    GenericNoResultsFoundText: "Keine Ergebnisse gefunden",
    Group: "Gruppe",
    HidePreview: "Vorschau ausblenden",
    History: "Geschichte",
    Home: "Start",
    HubAssociatedHubs: "Zugehörigen Hubwebsites",
    HubAssociatedSites: "Zugehörigen Websites",
    HubSite: "Hubwebsite",
    IndividualFilesUpdated: "Einzelne Dateien aktualisiert",
    Importance: "Wichtigkeit",
    InReplyTo: "In Antwort auf",
    InsertAsAttachment: "Als Anhang einfügen",
    InsertAsLink: "Als Link einfügen",
    InsertFrom: "Einfügen von",
    InvalidEmail: "Ungültige E-Mail",
    Item: "Element",
    Items: "Elemente",
    ItemsToAddAsAttachmentsLinks: "Als {placeholder} hinzuzufügende Elemente",
    ItemToCopy: "Zu kopierendes Element",
    ItemsToCopy: "Zu kopierende Elemente",
    ItemToMove: "Zu verschiebendes Element",
    ItemsToMove: "Zu verschiebende Elemente",
    ItemsSelected: "ausgewählte Elemente",
    LandingPage: "Landing page",
    LargestOnTop: "Größte oben",
    LeastRelevantOnTop: "Wenigste relevant oben",
    LevelUp: "Level aufsteigen",
    LibraryPermissions: "Bibliotheksrechte",
    LicenseRequired: "Um Zugang zu {placeholder} zu haben, benötigen Sie eine kostenpflichtige Lizenz.",
    LicenseRequiredTitle: "Lizenz erforderlich",
    LimitReached: "Limit erreicht",
    Link: "Link",
    ListItemPickerSelectValue: "Wert auswählen",
    List: "Liste",
    Lists: "Listen",
    ListItem: "Listenelement",
    Loading: "Lade...",
    LoadingOnly: "Wird geladen",
    LoadingFilters: "Filter laden",
    LoadingInputs: "Eingaben laden",
    LoadingProfile: "Profil wird geladen...",
    LoadDefaults: "Standardwerte laden",
    LoadMore: "Mehr Ergebnisse laden",
    LoadingEmails: "E-Mails laden",
    Local: "lokal",
    Location: "Standort",
    Locations: "Microsoft 365-Standorte",
    MailboxAddress: "Mailbox-Adresse",
    MailboxAuthorizing: "Mailbox autorisieren",
    MailboxAlreadyAdded: "Mailbox bereits hinzugefügt",
    Manage: "Verwalten",
    MaximumEmailMessagesSelected: "Maximal {amount} E-Mail-Nachrichten können gleichzeitig gespeichert werden.",
    Me: "Ich",
    Member: "Mitglied",
    Members: "Mitglieder",
    MembersAdd: "Mitglieder hinzufügen",
    MemberSelect: "Mitglied auswählen",
    MembersNotSelected: "Keine Mitglieder ausgewählt",
    MembersNotFound: "Keine Mitglieder gefunden",
    Message: "Nachricht",
    MessageId: "Nachrichten-ID",
    MetadataNotUpdated: "Dateien wurden erfolgreich gespeichert. Stellen Sie sicher, dass die Metadaten entsprechend aktualisiert wurden",
    MetadataValidationFailed: "Validierung fehlgeschlagen für",
    MinorVersions: "Nebenversionen (Entwürfe)",
    Modified: "Geändert",
    ModifiedBy: "Geändert von",
    More: "Mehr",
    MoreActions: "Aktionen anzeigen",
    MostRelevantOnTop: "Am relevantesten oben",
    MoveItemUp: "Angeheftetes Element nach oben verschieben",
    MoveItemDown: "Angeheftetes Element nach unten verschieben",
    MoveItems: "Elemente verschieben",
    MovingItems: "Verschiebe Elemente...",
    MoveProgress: "Fortschritt verschieben",
    MoveProgressCounter: "{completed} von {total} Elementen verschoben",
    MoveAll: "Alle verschieben",
    MoveTo: "Verschieben nach",
    MyApprovals: "Meine Genehmigungen",
    Name: "Name",
    New: "Neue",
    NewestOnTop: "Neueste oben",
    NewOnly: "Neu",
    No: "Nein",
    NoAppSpecificFiles: "Keine {context} Dateien gefunden.",
    NoEmailAvailable: "Keine E-Mail verfügbar",
    NoFiltersAvailable: "Keine Filter verfügbar",
    NoFilesSelected: "Keine Dateien ausgewählt",
    NoItemsFound: "Keine Elemente gefunden!",
    NoMoreFolders: "In diesem Verzeichnis befinden sich keine Ordner!",
    NoMoreFoldersAndFiles: "Dieses Verzeichnis ist leer.",
    NoLocations: "Keine weiteren Standorte",
    NotAssignedToTeam: "Sie sind Mitglied keines Teams.",
    NotAssignedToSite: "Sie sind keiner Website zugeordnet.",
    NoResultsFound: "Keine Ergebnisse gefunden",
    NoSubject: "Kein Betreff",
    NotWorkingOnOnlineVersion: "Sie arbeiten nicht an der Online-Version dieses Dokuments.",
    Of: "von",
    Ok: "Ok",
    OldestOnTop: "Älteste oben",
    OneDrive: "OneDrive",
    OneOrMoreFilesLockedCheckedOut: "Eine oder mehrere Dateien gesperrt/ausgecheckt",
    Open: "Öffnen",
    OpenFileInBrowser: "Datei im Browser öffnen",
    OpenFileLocation: "Dateiort öffnen",
    OpenFileLocationIn: "Dateiort öffnen in",
    OpenIn: "Öffnen in",
    OpenFolder: "Ordner öffnen",
    OpenOnlineDocumentWith: "Das Dokument öffnen in",
    OpenFolderInBrowser: "Ort im Browser öffnen",
    OptionalComment: "Einen Kommentar hinzufügen (optional)",
    Options: "Optionen",
    OutlookSettings: "Outlook-Einstellungen",
    OriginalSubject: "Ursprünglicher Betreff",
    Overview: "Überblick",
    Overwrite: "Überschreiben/Version vorhandener Dateien",
    OverwriteRequired: "Ändern Sie den/die widersprüchlichen Dateinamen oder wählen Sie die Option, vorhandene Dateien zu überschreiben/versionieren.",
    Owner: "Eigentümer",
    Participants: "Teilnehmer",
    Permissions: "Berechtigungen",
    Pinned: "Angepinnt",
    PinnedItemsShownHere: "Angepinnte Elemente werden hier angezeigt.",
    PinThisFile: "Diese Datei anpinnen",
    PinThisFolder: "Diesen Ort anpinnen",
    PleaseSelectSomeoneShare: "Bitte wählen Sie jemanden zum Teilen aus",
    PriceLinkText: "Unsere Preise können Sie hier einsehen.",
    PrivacySensitiveChecking: "Prüfung auf datenschutzsensible Daten",
    PrivacySensitiveCheckError: "Fehler bei der Prüfung auf datenschutzsensible Daten",
    PrivacySensitiveDisplay: "Datenschutzsensibel",
    PrivacySensitiveDataFound: "Datenschutzsensible Daten gefunden",
    PrivacySensitiveDataNotFound: "Keine datenschutzsensiblen Daten gefunden",
    PrivacySensitiveDataNotChecked: "Datenschutzsensible Daten nicht geprüft",
    PrivacySensitiveRedact: "Datenschutzsensible Daten schwärzen",
    Private: "Privat",
    Preferences: "Einstellungen",
    PreparingCopy: "Kopiervorgang vorbereiten...",
    PreparingMove: "Umzugsvorgang vorbereitet...",
    Properties: "Eigenschaften",
    Publish: "Veröffentlichen",
    PublishedMajorVersion: "Aktuelle veröffentlichte Hauptversion",
    QuickAccess: "Schnellzugriff",
    ReadMore: "Weiterlesen...",
    ReadOnly: "Nur Lesen",
    Reason: "Grund",
    Reassign: "Neu zuweisen",
    ReassignTo: "Neu zuweisen an",
    Recipients: "Empfänger",
    Received: "Erhalten",
    Recent: "Kürzlich",
    RecentlyEditYou: "Sie haben dies kürzlich bearbeitet",
    RecentlyOpened: "Kürzlich geöffnet",
    RecentlyOpenedYou: "Sie haben dies kürzlich geöffnet",
    RecentItemsShownHere: "Kürzliche Elemente werden hier angezeigt.",
    Recheck: "Nochmals prüfen",
    Recommended: "Empfohlen",
    Redact: "Schwärzen",
    References: "Referenzen",
    Refresh: "Aktualisieren",
    Reject: "Ablehnen",
    Relevance: "Relevanz",
    Remove: "Entfernen",
    RemoveFromRecent: "Aus Kürzlich entfernen",
    RemoveFromSuggestions: "Aus Vorschlägen entfernen",
    RenameOnly: "Umbenennen",
    Rename: "Automatisch umbenennen",
    RenameTextFileOption: "Sie haben Dateinamen, die in diesem Ordner bereits existieren. Bitte geben Sie eine Option an.",
    ReplaceOnly: "Ersetzen",
    Replace: "Ersetzen/Versionieren",
    ReplaceFile: "Datei ersetzen",
    ReplacementFileRequired: "Ersatzdatei erforderlich.",
    ReplacementFileRequiredMessage: "Bitte wählen Sie eine Ersatzdatei aus der Liste der verfügbaren Dateien oder durchsuchen Sie nach einer Datei.",
    ReplyTo: "Antworten an",
    RequestAccess: "Zugriff anfordern",
    Requester: "Anforderer",
    Required: "Erforderlich",
    Reset: "Zurücksetzen",
    Restoring: "Wiederherstellen",
    RetrievingFolders: "Ordner abrufen",
    RetrievingFoldersAndFiles: "Dateien und Ordner abrufen",
    RetrievingInfo: "Informationen abrufen",
    RetryAfter: "Bitte versuchen Sie es in einigen Minuten erneut",
    RequestTrial: "Eine kostenlose Testversion anfordern",
    RequestTrialText: "Mit unserer Testversion können Sie Docubird kostenlos ausprobieren. Damit Docubird richtig funktioniert, ist es wichtig zu wissen, wie Sie SharePoint und Teams implementiert haben.",
    Save: "Speichern",
    SaveAll: "Alle speichern",
    SaveAsPDFQuestion: "Als PDF speichern?",
    SaveInProgress: "Speichern läuft ...",
    SaveProperties: "Eigenschaften speichern",
    SavingDisabled: "Speichern deaktiviert",
    SavingFile: "Datei speichern",
    SavingFiles: "Dateien speichern",
    SavingFilesNotAllowed: "Das Speichern von Dateien an diesem Ort ist nicht erlaubt",
    SaveAsPdf: "Als pdf speichern",
    SaveMail: "Diese Mail speichern?",
    SaveOnSend: "Beim Senden speichern",
    SaveSelection: "Auswahl speichern",
    SaveSelected: "Ausgewählte E-Mail(s) speichern",
    SaveSelectedFiles: "Ausgewählte Dateien speichern",
    SaveEntireFolder: "Gesamten Ordner speichern",
    SaveEmails: "E-Mail(s) speichern",
    SaveEmailsConfirmBody: "Nach dem Klicken auf den \"OK\"-Button werden Sie zum Startbildschirm weitergeleitet, um einen Ort auszuwählen, an dem Sie die E-Mails speichern möchten.",
    SaveTo: "Speichern in ",
    SaveToAnotherLocation: "In einem anderen Ort speichern",
    Search: "Suchen",
    SearchDescription: "Suche nach einer spezifischen Site",
    SearchFields: "Suchfelder",
    SearchResults: "Suchergebnisse",
    SearchResultsRetrieval: "Suchergebnisse abrufen...",
    SearchSectionFilter: "Suche {section} Filter",
    SearchingContent: "Inhalte suchen...",
    SearchingFor: "Ich suche",
    Select: "Auswählen",
    SelectAFile: "Eine Datei auswählen",
    Selected: "Ausgewählt",
    SelectedFile: "Ausgewählte Datei",
    SelectAction: "Aktion auswählen",
    SelectDestinationDirectory: "Bitte wählen Sie ein Zielverzeichnis.",
    SelectDestinationDirectoryConfirmCopy: "Sind Sie sicher, dass Sie {amount} Elemente von {source} in das aktuelle Verzeichnis kopieren möchten?",
    SelectDestinationDirectoryConfirmMove: "Sind Sie sicher, dass Sie {amount} Elemente von {source} in das aktuelle Verzeichnis verschieben möchten?",
    SelectItemsToSave: "Zu speichernde Elemente auswählen",
    SelectOption: "Eine Option auswählen",
    SelectSaveLocation: "Wählen Sie einen Speicherort",
    SelectSensitivityLabel: "Wählen Sie ein Sensitivitätsetikett",
    SelectSpecificDates: "Bestimmte Daten auswählen",
    SelectTerm: "Begriff auswählen",
    Send: "Senden",
    Sending: "Senden",
    SendInMessage: "Nachricht senden",
    Sensitivity: "Sensitivität",
    Share: "Teilen",
    Shared: "Geteilt",
    SharedBy: "Geteilt durch",
    ShareWith: "Teilen mit",
    SharedWith: "Geteilt mit",
    SharedThisItem: "Dieses Element geteilt",
    SharedItemsShownHere: "Mit Ihnen geteilte Dateien werden hier angezeigt.",
    SharedMailboxes: "Geteilte Postfächer",
    SharepointDocumentLibrary: "SharePoint Dokumentenbibliothek",
    SharePointDocumentSet: "SharePoint Dokumentensatz",
    SharepointFolder: "SharePoint Ordner",
    SharePointHubSite: "SharePoint-Hubwebsite",
    SharepointSite: "SharePoint Site",
    SharepointSubsite: "SharePoint Unterwebsite",
    ShowDateRangeSlider: "Datumsbereichs-Schieberegler anzeigen",
    ShowLess: "Weniger anzeigen",
    ShowMore: "Mehr anzeigen",
    ShowPinned: "Angeheftete anzeigen",
    ShowPreview: "Vorschau anzeigen",
    ShowRecent: "Kürzlich anzeigen",
    ShowShared: "Geteiltes anzeigen",
    SigningIn: "Anmelden ...",
    SigningRequest: "Antrag auf Unterzeichnung",
    SignInWithDifferentAccount: "Mit einem anderen Konto anmelden",
    SigningRequestCreated: "Signieranforderung erstellt",
    SigningRequestError: "Signierungsanfrage fehlgeschlagen",
    SitePermissions: "Site-Berechtigungen",
    Sites: "Websites",
    SitesFollowedShownHere: "Websites, denen Sie folgen, werden hier angezeigt.",
    Size: "Größe",
    SmallestOnTop: "Kleinste oben",
    SortBy: "Sortieren nach",
    SortOrder: "Sortierreihenfolge",
    Status: "Status",
    Subject: "Betreff",
    SubmitForApproval: "Zur Genehmigung einreichen",
    Subsites: "Unterwebsite",
    Success: "Erfolg",
    SuggestedContacts: "Vorgeschlagene Kontakte",
    SuggestedPeople: "Vorgeschlagene Personen",
    SuggestedValues: "Vorgeschlagene Werte",
    Suggestions: "Vorschläge",
    SuggestedItemsShownHere: "Vorgeschlagene Standorte werden hier angezeigt.",
    TaxonomyPickerNoTerms: "Term Set enthält keine Begriffe",
    TaxonomyPickerExpandTitle: "Dieses Term Set erweitern",
    TaxonomyPickerMenuTermSet: "Menü für Term Set",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerTermSetLabel: "Term Set",
    TaxonomyPickerTermsNotFound: "Die nächsten ausgewählten Begriffe konnten nicht im Term Store gefunden werden: {0}",
    TaxonomyPickerInvalidTerms: "Ungültige(r) Begriff(e): {0}",
    TeamsChannel: "Teams Kanal",
    TeamsChannelNotLoaded: "Der Speicherort für die Dateien dieses Kanals wurde noch nicht bereitgestellt.",
    TeamsFolder: "Teams Ordner",
    TeamsSite: "Teams Website",
    Title: "Titel",
    TitleAutoSet: "[Automatisch auf E-Mail-Betreff / Dateiname eingestellt]",
    To: "An",
    Trending: "Trend",
    TrialExpiredText: "Ihre kostenlose 30-Tage-Testversion ist abgelaufen. Möchten Sie Docubird weiterhin nutzen?",
    Type: "Typ",
    UnableToAttach: "E-Mail-Anhänge können nicht angehängt werden!",
    UnableToAttachTryAgain: "E-Mail-Anhänge können nicht angehängt werden! Bitte versuchen Sie es erneut!",
    UnableToAppendLinkTryAgain: "Ein freigebbarer Link kann nicht angehängt werden! Bitte versuchen Sie es erneut!",
    UnableToRetrieveFile: "Die aktuelle Datei konnte nicht abgerufen werden! Bitte versuchen Sie es erneut!",
    UnableToRetrieveTeams: "Wir konnten Ihre Team websites nicht abrufen",
    Unassigned: "Nicht zugewiesen",
    Unknown: "Unbekannt",
    UnpinFile: "Diese Datei lösen",
    UnpinFolder: "Diesen Ort lösen",
    Unpublish: "Zurückziehen",
    UpdateIndividualFile: "Einzelne Datei aktualisieren",
    UpdateIndividualFileMetaData: "Metadaten einer einzelnen Datei aktualisieren",
    Upload: "Hochladen",
    UploadCompletedSuccessfully: "Upload erfolgreich abgeschlossen",
    UploadFiles: "Dateien hochladen",
    UsersAddError: "Beim Hinzufügen eines oder mehrerer Benutzer ist ein Fehler aufgetreten",
    UserChangingRole: "Benutzerrolle wird geändert",
    UserRemove: "Benutzer entfernen",
    ValuesNotFound: "Werte nicht gefunden",
    VerifyingFiles: "Dateien werden überprüft",
    Views: "Ansichten",
    ViewPendingApprovalsWindow: "Alle ausstehenden Genehmigungen in separatem Fenster anzeigen.",
    Version: "Version",
    VersionHistory: "Versionsverlauf",
    VersionMinorDraft: "Minderheitsversion (Entwurf)",
    VersionMinorOverwrite: "Aktuelle Minderheitsversion überschreiben",
    VersionMajorPublished: "Hauptversion (veröffentlicht)",
    VersionsDeleteAll: "Alle Versionen löschen",
    VersionsDeleteMinors: "Minderheitsversionen löschen",
    VersionDelete: "Löschen",
    VersionRestore: "Wiederherstellen",
    VersionConfirmDeleteAllMessage: "Möchten Sie wirklich alle Versionen löschen?",
    VersionConfirmDeleteAllMinorMessage: "Möchten Sie wirklich alle Minderheitsversionen löschen?",
    VersionStatusApproved: "Genehmigt - Dieser Artikel wird für alle Benutzer sichtbar",
    VersionStatusRejected: "Abgelehnt - Dieser Artikel wird nur an den Ersteller zurückgegeben",
    VersionStatusPending: "Ausstehend - Dieser Artikel bleibt für seinen Ersteller und alle Benutzer sichtbar, die Entwurfsartikel sehen können",
    VersionView: "Anzeigen",
    Welcome: "Willkommen",
    WelcomeLoginText: "Melden Sie sich bei Microsoft 365 an",
    WelcomeText: "Docubird ist ein Microsoft 365-Add-In zur Optimierung der Dokumentenverwaltung in SharePoint, OneDrive und Teams.",
    WrongUserPermissionsSave: "Sie haben nicht die erforderlichen Berechtigungen, um Dateien an diesem Speicherort zu speichern.",
    WrongUserPermissionsUpdate: "Sie haben nicht die erforderlichen Berechtigungen, um Dateien an diesem Speicherort zu aktualisieren.",
    Yes: "Ja",
    You: "Sie"
  }
};

export const LanguageContext = React.createContext(locales.en);

export class LocalizationModule {
  static getLocaleStrings(locale: string) {
    try {
      const localeLang = locale.toLowerCase().substring(0, 2);
      switch (localeLang) {
        case "en":
          return locales.en;
        case "nl":
          return locales.nl;
        case "de":
          return locales.de;
        default:
          return locales.en;
      }
    } catch (error) {
      return locales.en;
    }
  }
}
